interface StoreHours {
  dayOfWeek: number; // 1 (Monday) - 7 (Sunday)
  from1?: string;
  to1?: string;
  closed?: boolean;
}
export const getDayOfTheWeek = (day: number) => {
  const dayOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  return dayOfWeek[day % 7];
};
export const convertTo12HourFormat = (time: string) => {
  const [hours, minutes] = time.split(":").map(Number);
  const suffix = hours >= 12 ? "PM" : "AM";
  const hours12 = hours % 12 || 12;

  return `${hours12}:${minutes.toString().padStart(2, "0")} ${suffix}`;
};

const getStoreStatus = (storeHours: StoreHours[], now: Date) => {
  const currentDay = now.getDay() === 0 ? 7 : now.getDay(); // Convert Sunday from 0 to 7
  const currentTime = now.getHours() * 100 + now.getMinutes(); // Convert current time to comparable format

  const todayHours =
    storeHours.find((day) => day.dayOfWeek === currentDay) ?? null;

  if (todayHours?.closed) {
    // If the store is closed today, find the next opening time
    const nextOpeningDay = storeHours.find(
      (day) => day.dayOfWeek > currentDay && day.from1
    );
    return {
      status: "Closed.",
      nextAction: `Opens ${convertTo12HourFormat(
        nextOpeningDay!.from1 ?? "00:00"
      )} ${getDayOfTheWeek(nextOpeningDay!.dayOfWeek)}`,
    };
  } else if (todayHours) {
    //const openingTime = parseInt(todayHours.from1!.replace(":", ""), 10);
    //const closingTime = parseInt(todayHours.to1!.replace(":", ""), 10);
    return {
      status: `Open today ${convertTo12HourFormat(todayHours.from1!)}`,
      nextAction: `- ${convertTo12HourFormat(todayHours.to1!)}`,
    };
  } else {
    throw Error("no store hours passed");
  }
};
export default getStoreStatus;
